/**
 * Actions Constants
 * Defines all available actions in the system
 */
export const ACTIONS = {
  VIEW: "view",
  EDIT: "edit",
  ADD: "add",
  DELETE: "delete",
  VIEW_PERSONAL_DATA: "view_personal_data",
} as const;

/**
 * Action Type
 * Union type of all possible action values
 */
export type Action =
  | typeof ACTIONS.VIEW
  | typeof ACTIONS.EDIT
  | typeof ACTIONS.ADD
  | typeof ACTIONS.DELETE
  | typeof ACTIONS.VIEW_PERSONAL_DATA;

/**
 * Array of all action values
 */
export const ACTIONS_LIST: readonly Action[] = [
  ACTIONS.VIEW,
  ACTIONS.EDIT,
  ACTIONS.ADD,
  ACTIONS.DELETE,
  ACTIONS.VIEW_PERSONAL_DATA,
] as const;
